import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { createAuth0 } from '@auth0/auth0-vue'
import { fetchConfig, getConfigForAuth0 } from '@/api/config'
import { setAuth0Client } from '@/auth0-client'
import './assets/main.css'

/* Theme: set from VITE_THEME (classic | stillup2) so CSS can switch via [data-theme="stillup2"] */
const theme = import.meta.env.VITE_THEME === 'stillup2' ? 'stillup2' : 'classic'
document.documentElement.dataset.theme = theme

async function bootstrap() {
  await fetchConfig()
  const auth0Config = getConfigForAuth0()

  let auth0Plugin: ReturnType<typeof createAuth0> | null = null
  if (auth0Config) {
    const baseUrl = (import.meta.env.BASE_URL ?? '/').replace(/\/$/, '') || ''
    const callbackPath = `${baseUrl}/callback`
    const redirectUri = `${window.location.origin}${callbackPath}`

    auth0Plugin = createAuth0({
      domain: auth0Config.domain,
      clientId: auth0Config.clientId,
      authorizationParams: {
        redirect_uri: redirectUri,
        audience: auth0Config.audience,
        scope: 'openid profile email offline_access',
      },
      // Use refresh tokens so the session survives beyond the 24h access-token
      // lifetime.  Auth0 refresh tokens are configured for 30 days server-side.
      useRefreshTokens: true,
      // Persist tokens in localStorage so they survive page refresh / browser restart.
      cacheLocation: 'localstorage',
    })
  }

  const app = createApp(App)
  app.use(createPinia())
  app.use(router)
  if (auth0Plugin) {
    app.use(auth0Plugin)
    const auth0 = (app.config.globalProperties as { $auth0?: import('@auth0/auth0-vue').Auth0VueClient }).$auth0
    setAuth0Client(auth0 ?? null)
  }
  app.mount('#app')
}

bootstrap().catch((e) => {
  console.error('App bootstrap failed:', e)
  document.getElementById('app')!.innerHTML = '<p style="padding:2rem;color:#f85149;">Failed to load app. Check console.</p>'
})
